import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';

const ACTIONS = createAsyncActions('SERVER.PREMIUM-INFO.GET');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


export default function (force) {
  return function (dispatch) {
    dispatch(START());

    return Promise.all([
        vodAdapter.premium.getPremiumInfo(force),
        vodAdapter.premium.getUsage(),
      ])
      .then(
        function ([premiumInfo, usageInfo]) {
          return { premiumInfo, usageInfo };
        },

        function (reason) {
          dispatch(FAIL(null, null, { analytics: { type: 'error', name: 'shared.premium-info.get' } }));
          return Promise.reject(reason);
        }
      )
      .then(function (data) {
        dispatch(SUCCESS({}, data));
        return data;
      });
  };
}



// WEBPACK FOOTER //
// ./src/shared/redux/server/actions/premium-info/get.js